import api from './../../service/apiService'
import { apiUrl } from './../../constants/apiUrl'
import { logKafka, logOtherInfo, detailsInfo, logToKibanna } from './../../service/logService'
import { redirectTo } from './redirection'
import { errorAction } from './error';
import { Deposit, CheckOut, FinalBill, Pages, PAGEACTIVITY } from './../../constants/actionType'
import { getPieEncryptionVepsPayment } from './../../util/commonUtil'
import { updateSCcustomEvent, tempSCData } from './../../service/change/dtmTag';
import { InHomeUtils } from './../../util/inhomeUtils';
import { store } from '../../../src/index';

let getLogUrl = apiUrl().kafkaErrorAppLogs;
let kafkaPageLogs = apiUrl().kafkaPageLogs;

export const validateDeposit = (action, dispatch) => {
    dispatch({ type: Deposit.validateDeposit, value: action });
}

const doFinalBillPayment = (visitId, dispatch, amount, inputDetail, lqState, noOfAttempts) => {
    let paymentCheck = apiUrl().vepsUrl;
    dispatch({
        type: 'LOADER_ACTIVE',
        value: { isLoaderActive: true, isLoaderText: "", isLoaderImg: "loader" }
    });
    let request = getPaymentRequest(amount, inputDetail, lqState, false, visitId);
    if (noOfAttempts < 3) {
        api(paymentCheck, 'POST', request).then(response => {
            //response= resp.finalBillResponse;
            if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.meta) && InHomeUtils.getIndexOf(response.meta.code, "200") && InHomeUtils.isNotNull(response.data) && InHomeUtils.isNotNull(response.data.status)) {
                dispatch({ type: FinalBill.onUpdateFinalBill, value: response.data });

                if (response.data.status === 'Success') {
                    dispatch({ type: FinalBill.finalBillStatus, value: 'success' })

                    tempSCData.detailPageName = "ec| services overview| info and credit- crd chk";
                    tempSCData.creditCheck = "Pass";
                    updateSCcustomEvent("checkoutInit", "ddCheckoutEvent", "detailPageName");
                }
                else if (response.data.status === 'Failed') {
                    dispatch({ type: FinalBill.finalBillStatus, value: 'fail' })
                    dispatch({ type: CheckOut.updateFinalBillAttempts, value: noOfAttempts + 1 })
                    dispatch({ type: CheckOut.updateCreditCheckAccordionStatus, value: 'required' })
                    dispatch({ type: CheckOut.updateRTAStatus, value: false })
                    dispatch({ type: CheckOut.onUpdateCreditCheckStatus, value: false })
                    dispatch({ type: CheckOut.updateFinalBillStatus, value: true })

                    tempSCData.detailPageName = "ec| services overview| install tos and summary - install| credit fail";
                    tempSCData.creditCheck = "Fail";
                    updateSCcustomEvent("installandtosLoad", "ddCheckoutEvent", "detailPageName");

                    logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.CO, visitId, PAGEACTIVITY.PAGE.ASYNC, 'FINALBILL VEPS REJECTED_CNT:' + noOfAttempts, PAGEACTIVITY.UA));
                    logKafka("ERROR", "Checkout", "FINALBILL VEPS REJECTED_CNT:" + noOfAttempts, getLogUrl, "applogs", visitId);
                }
            }
            else if (response.meta.code === 500.01) {
                dispatch({ type: CheckOut.updateFinalBillAttempts, value: noOfAttempts + 1 })
                dispatch({ type: FinalBill.finalBillStatus, value: 'fail' })
                dispatch({ type: CheckOut.onUpdateCreditCheckStatus, value: false })
                dispatch({ type: CheckOut.updateRTAStatus, value: false })
                dispatch({ type: CheckOut.updateFinalBillStatus, value: true })
                logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.CO, visitId, PAGEACTIVITY.PAGE.ASYNC, 'FINALBILL VEPS API Error_CNT:' + noOfAttempts, PAGEACTIVITY.UA));
                logKafka("ERROR", "Checkout", "FINALBILL VEPS REJECTED_CNT:" + noOfAttempts, getLogUrl, "applogs", visitId);
            } else {
                logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.CO, visitId, PAGEACTIVITY.PAGE.ASYNC, 'FINALBILL VEPS API Error_CNT:' + noOfAttempts, PAGEACTIVITY.UA));
                logKafka("ERROR", "Checkout", "FINALBILL VEPS REJECTED_CNT:" + noOfAttempts, getLogUrl, "applogs", visitId);
            }
            dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
        })
            .catch(error => {
                let getErrorLogUrl = apiUrl().kafkaErrorAppLogs;
                let errorMsg = `MethodName:doFinalBillPayment,errorMessage:${error.message}`;
                logKafka("ERROR", "Checkout", errorMsg, getErrorLogUrl, "applogs", visitId);
                dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
            });
    }
    else {
        dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
        dispatch({ type: CheckOut.onUpdateCreditCheckStatus, value: false })
        dispatch({ type: CheckOut.updateRTAStatus, value: false })
        dispatch({ type: FinalBill.finalBillStatus, value: 'fail' })
        dispatch({ type: CheckOut.updateFinalBillStatus, value: true })
    }
}

const doDepositPayment = (visitId, visitorid, dispatch, amount, inputDetail, lqState, noOfAttempts, isTargetOrdering, pfbautopayState) => {
    let paymentCheck = apiUrl().vepsUrl;
    dispatch({
        type: 'LOADER_ACTIVE',
        value: { isLoaderActive: true, isLoaderText: "<h2>Please wait.This should only take a moment</h2>", isLoaderImg: "spinner" }
    });

    let request = getPaymentRequest(amount, inputDetail, lqState, true, visitId);
    api(paymentCheck, 'POST', request).then(response => {
        if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.meta) && InHomeUtils.isNotNull(response.meta.code) && InHomeUtils.getIndexOf(response.meta.code, "200") && InHomeUtils.isNotNull(response.data) && InHomeUtils.isNotNull(response.data.status)) {
            dispatch({ type: Deposit.onUpdateDeposit, value: response.data });

            if (response.data.status === 'Success') {
                dispatch({ type: Deposit.updateDepositStatus, value: 'success' })
                dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
                logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.PO, visitId, 'doDepositPayment', "SUBMITORDER-CALLED", PAGEACTIVITY.UA));
                logKafka("INFO", "submitOrder", "SUBMITORDER-CALLED" , kafkaPageLogs, "applogs", visitId);
                doSumbitOrder(visitId, visitorid, dispatch, isTargetOrdering, pfbautopayState);
            }
            else if (response.data.status === 'Failed') {
                dispatch({ type: Deposit.updateDepositAttempts, value: noOfAttempts + 1 })
                dispatch({ type: Deposit.updateDepositStatus, value: 'fail' })
                dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
                logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.CO, visitId, PAGEACTIVITY.PAGE.ASYNC, 'DEPOSIT VEPS REJECTED_CNT:' + noOfAttempts, PAGEACTIVITY.UA));
                logKafka("ERROR", "submitOrder", "DEPOSIT VEPS REJECTED_CNT:" + noOfAttempts , getLogUrl, "applogs", visitId);
            }
        }
        else if (InHomeUtils.getIndexOf(response.meta.code, "500")) {
            dispatch({ type: Deposit.updateDepositAttempts, value: noOfAttempts + 1 })
            dispatch({ type: Deposit.updateDepositStatus, value: 'fail' })
            dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
            logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.CO, visitId, PAGEACTIVITY.PAGE.ASYNC, 'DEPOSIT VEPS API Error_CNT:' + noOfAttempts, PAGEACTIVITY.UA));
            logKafka("ERROR", "submitOrder", "DEPOSIT VEPS API Error_CNT:" + noOfAttempts , getLogUrl, "applogs", visitId);
        }
        else {
            logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.CO, visitId, PAGEACTIVITY.PAGE.ASYNC, 'DEPOSIT VEPS API Error_CNT:' + noOfAttempts, PAGEACTIVITY.UA));
            logKafka("ERROR", "submitOrder", "DEPOSIT VEPS API Error_CNT:" + noOfAttempts , getLogUrl, "applogs", visitId);
        }
    })
        .catch(error => {
            let getErrorLogUrl = apiUrl().kafkaErrorAppLogs;
            let errorMsg = `MethodName:doDepositPayment,errorMessage:${error.message}`;
            logKafka("ERROR", "Checkout", errorMsg, getErrorLogUrl, "applogs", visitId);
            dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
        });
}

export const doVepsPayment = (visitId, visitorid, dispatch, amount, inputDetail, lqState, IsDeposit, noOfAttempts, isTargetOrdering, pfbautopayState) => {
    if (IsDeposit) {
        doDepositPayment(visitId, visitorid, dispatch, amount, inputDetail, lqState, noOfAttempts, isTargetOrdering, pfbautopayState)
    }
    else {
        doFinalBillPayment(visitId, dispatch, amount, inputDetail, lqState, noOfAttempts)
    }
};

const getPaymentRequest = (amount, inputDetail, lqState, IsDeposit, visitId) => {
    let address = '';
    let city = '';
    let state = '';
    let zip = '';
    let year = '';
    let addressCheck = false;
    let encryption = {
        cardNum: IsDeposit ? inputDetail.deposit.cardNumber : inputDetail.finalBill.cardNumber,
        securityCode: IsDeposit ? inputDetail.deposit.securityCode : inputDetail.finalBill.securityCode
    }
    let encryptedValue = getPieEncryptionVepsPayment(encryption, visitId);
    var rand = String(Math.floor(100000000000 + Math.random() * new Date().valueOf()));
    var esignrand = rand.length > 12 ? rand.substring(0, 12) : rand;
    if (IsDeposit) {
        inputDetail = inputDetail.deposit;
        addressCheck = inputDetail.depositAddressCheck;
    }
    else {
        inputDetail = inputDetail.finalBill;
        addressCheck = inputDetail.finalBillAddressCheck;
    }
    if (addressCheck) {
        let unit = (InHomeUtils.isNotNull(lqState.selectedUnit) && InHomeUtils.isNotNull(lqState.selectedUnit.unit)) ? lqState.selectedUnit.unit : "";
        address = `${lqState.selectedAdr.street} ${unit}`
        city = lqState.selectedState.altCity;
        state = lqState.selectedState.state;
        zip = lqState.selectedState.zip;
    }
    else {
        address = inputDetail.street;
        city = inputDetail.city;
        state = inputDetail.stateVal;
        zip = inputDetail.zip;
    }
    if (inputDetail.expirationDate.Year != null) {
        year = (inputDetail.expirationDate.Year).substring(2, 4);
    }
    let expDate = (inputDetail.expirationDate.Month + year);
    let request = '';
    if (IsDeposit) {
        request = [{
            client: { name: 'vzcom', id: 'vzcom' },
            data: {
                serviceAction: "deposit",
                transactionSource: "Desktop",
                orderType: "NEW",
                depositamount: amount,
                paymentDetails: [{
                    pmtInd: inputDetail.debitCheck ? "D" : "C",
                    pmtType: inputDetail.cardType,
                    cardNum: encryptedValue ? encryptedValue[0] : '',
                    securityCode: encryptedValue ? encryptedValue[1] : '',
                    profileName: Math.floor(new Date().valueOf() * Math.random()),
                    expirationDt: expDate,
                    payeeName: (inputDetail.firstName + " " + inputDetail.lastName),
                    payeeAddress: address,
                    payeeCity: city,
                    payeeState: state,
                    payeeZipCode: zip,
                }]
            }
        }]
    }
    else {
        request = [{
            client: { name: 'vzcom', id: 'vzcom' },
            data: {
                serviceAction: "regularpayment",
                transactionSource: "Desktop",
                orderType: "NEW",
                paymentDetails: [{
                    pmtInd: inputDetail.debitCheck ? "D" : "C",
                    pmtType: inputDetail.cardType,
                    cardNum: encryptedValue ? encryptedValue[0] : '',
                    securityCode: encryptedValue ? encryptedValue[1] : '',
                    profileName: "AUTO_17091775978299",
                    amount: amount,
                    expirationDt: expDate,
                    payeeName: (inputDetail.firstName + " " + inputDetail.lastName),
                    payeeAddress: address,
                    payeeCity: city,
                    payeeState: state,
                    payeeZipCode: zip,
                    actions: [{ actionCode: "NOTIFY_PPX", eSignConfirmationNum: esignrand, }],
                    bankEncryptionDetails: {
                        keyId: encryptedValue.key_id,
                        phasebit: encryptedValue.phase,
                    }
                }]
            }
        }]
    }
    return JSON.stringify(request);

}

const getRequestchat = (visitId, visitorId) => {
    let request = { visitId: visitId, visitorId: visitorId, callFrom: "submit" }
    return JSON.stringify(request);
};

const invokeSendLofNotification = (visitId, dispatch, pfbautopayState) => {
    let url = apiUrl().sendLofNotification;
    api(url, 'POST', getLofAutoPayRequest(visitId, pfbautopayState))
        .then(response => {
            console.log(response)
        })
        .catch(error => {
            let getErrorLogUrl = apiUrl().kafkaErrorAppLogs;
            let errorMsg = `MethodName:invokeSendLofNotification,errorMessage:${error.message}`;
            logKafka("ERROR", "ChatStore submit-error", errorMsg, getErrorLogUrl, "applogs", visitId);
        });
}

const getLofAutoPayRequest = (visitId, pfbautopayState) => {
    let request = {
        data: {
            email: pfbautopayState.lofAutoPayRequest.data.email,
            deliveryType: pfbautopayState.lofAutoPayRequest.data.deliveryType,
            mtn: pfbautopayState.lofAutoPayRequest.data.mtn,
            tosType: pfbautopayState.lofAutoPayRequest.data.tosType,
            pfbIntent: pfbautopayState.lofAutoPayRequest.data.pfbIntent,
            autopayIntent: pfbautopayState.lofAutoPayRequest.data.autopayIntent,
            autopayPromoFlag: pfbautopayState.lofAutoPayRequest.data.autopayPromoFlag,
            productDetails: pfbautopayState.lofAutoPayRequest.data.productDetails,
            orderStatus: "SUBMIT"
        }
    }
    return JSON.stringify(request);
}

export const doSumbitOrder = (visitId, visitorid, dispatch, isTargetOrdering, pfbautopayState, isTestDriveFlow = false) => {
    //  if(isTargetOrdering) {
    //      invokeSendLofNotification(visitId,dispatch,pfbautopayState)
    //  }
    logKafka("INFO", "submitOrder", "Inside SubmitOrder" , kafkaPageLogs, "applogs", visitId);
    let url = apiUrl().chatStore;
    console.log('validating the api call is being made')
    api(url, 'POST', getRequestchat(visitId, visitorid))
        .then(response => {
            console.log('validating the api call is being made success response 1')
            let getErrorLogUrl = apiUrl().kafkaErrorAppLogs;
            if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.meta) && InHomeUtils.getIndexOf(response.meta.code, "200") && InHomeUtils.isNotNull(response.chatInfo) && InHomeUtils.isNotNull(response.status)) {
                logKafka("SUCESS", "ChatStore submit", "ChatStore submit Success", getErrorLogUrl, "applogs", visitId);
            }
            else {
                logKafka("SUCESS", "ChatStore submit", "ChatStore submit Failure", getErrorLogUrl, "applogs", visitId);
            }
        })
        .catch(error => {
            let getErrorLogUrl = apiUrl().kafkaErrorAppLogs;
            let errorMsg = `MethodName:doSumbitOrder-Chat Store,errorMessage:${error.message}`;
            logKafka("ERROR", "ChatStore submit-error", errorMsg, getErrorLogUrl, "applogs", visitId);
        });

    let submitOrder = apiUrl().submitOrder;
    dispatch({
        type: 'LOADER_ACTIVE',
        value: { isLoaderActive: true, isLoaderText: "Submitting your order", isLoaderImg: "loader" }
    });
    const isRetailFiosReferralCheck = window.sessionStorage.getItem('fiosReferralFlow');
    const closingAgencyId = window.sessionStorage.getItem('closingAgencyId')
    const closingSalesCode = window.sessionStorage.getItem('closingSalesCode');
    if(isRetailFiosReferralCheck){
        const query = `closingAgencyId=${closingAgencyId}&closingSalesCode=${closingSalesCode}&posLocationCode=`
        let queryString = submitOrder.includes('?isMnFlow=Y') ? '&' : '?'
        queryString = queryString + query
        submitOrder = submitOrder + queryString
    }
    logToKibanna(`Inhome:submitOrder:2:${submitOrder}`, "INFO")
    const message =  sessionStorage.getItem("hostedAttractLoop") ? "fios-common-shell-order" : "fios-bau-order"
    logToKibanna(`Inhome:submitOrder:type:${message}`, "INFO")
    api(submitOrder, 'GET', '').then(response => {
        dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
        // if (window.nrTimeState && window.nrTimeState.fromTime) {
        //     logNRTime(window.nrTimeState, dispatch, 'Summary');
        // }
        if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.meta) && InHomeUtils.isNotNull(response.meta.code)) {
            if (response.meta.code === 200.02) {
                console.log('validating the api call is being made success response 2')
                logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.PO, visitId, 'doSumbitOrder', "SUBMITORDER-SUCCESS", PAGEACTIVITY.UA));
                logKafka("INFO", "submitOrder", "SUBMITORDER-SUCCESS" , kafkaPageLogs, "applogs", visitId);
                dispatch({ type: 'SO_SUBMIT_ORDER_SUCCESS', value: true });
                // redirectTo(Pages.SubmitOrder, dispatch)

                // For redirection upon successful LOF registration
                if (response.data.encZip) {
                    dispatch({ type: 'SET_ENC_ZIP', value: response.data.encZip })
                }
                if (response.data.encMon) {
                    dispatch({ type: 'SET_ENC_MON', value: response.data.encMon })
                }
            }
            else if (response.meta.code === 200.3 || response.meta.code === 500.01) {
                console.log('validating the api call is being made failure response')
                logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.PO, visitId, 'doSumbitOrder', "SUBMITORDER-FAILED", PAGEACTIVITY.UA));
                logKafka("ERROR", "submitOrder", "SUBMITORDER-FAILED" , getLogUrl, "applogs", visitId);
                dispatch({ type: 'SO_SUBMIT_ORDER_FAILURE', value: false });
                dispatch({ type: 'SET_ENC_ZIP', value: null });
                dispatch({ type: 'SET_ENC_MON', value: null });
            }
        }
    })
        .catch(error => {
            dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
            let errorMsg = `MethodName:doSumbitOrder,errorMessage:${error.message}`;
            let getErrorLogUrl = apiUrl().kafkaErrorAppLogs;
            logKafka("ERROR", "Submit", errorMsg, getErrorLogUrl, "applogs", visitId);
            errorAction("ERROR", "Checkout", error.message, "applogs", visitId, dispatch, false, "");
            // errorAction("LBO","Checkout",error.message,"applogs",visitId,dispatch,true,"SubmitOrderFail");
            dispatch({ type: 'SET_ENC_ZIP', value: null });
            dispatch({ type: 'SET_ENC_MON', value: null });
        });

    setTimeout(function () {
        submitOrderClicked(true, dispatch)
        //dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
        logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.PO, visitId, 'doSumbitOrder', "REDIRECTTO-SUBMITORDER", PAGEACTIVITY.UA));
        if (!isTestDriveFlow) {
            let isSecurehomeVhapunchout =store?.getState()?.buildProduct?.punchoutSecurehome || store?.getState()?.buildProduct?.punchoutSecurehomePlus || false;
            if(isSecurehomeVhapunchout){
                bridgeCallMethodSecureHome(store?.getState()?.buildProduct?.punchoutSecurehomeAction, store?.getState()?.buildProduct?.punchoutSecurehomeDtmTag);
            }else{
            redirectTo(Pages.SubmitOrder, dispatch);
            }
        }
    }, 3000);
};

const bridgeCallMethodSecureHome = (action = '',subscriptionType='') => {
    //Bridge call testing Start
    let msg = {
        actionType: "digitalSecurityEnrollment",
        actionItem: { actionName:action, subScriptionType: subscriptionType}
    }
    console.log("bridgeCallMethodSecureHome msg",JSON.stringify(msg));
    if (window?.webkit != undefined) {
        console.log('window.webkit',window.webkit);
        if (window.webkit?.messageHandlers?.mfAppInterface != undefined) {
        console.log('window.webkit.messageHandlers.mfAppInterface',window.webkit.messageHandlers.mfAppInterface);
            window.webkit.messageHandlers.mfAppInterface?.postMessage(JSON.stringify(msg));
        }
    }
    if (window?.mfAppInterface != undefined) {
        console.log('window.mfAppInterface',window.mfAppInterface);
        window.mfAppInterface?.postMessage(JSON.stringify(msg));
    }
    //Bridge call testing End
};


const submitOrderClicked = (status, dispatch) => {
    dispatch({ type: "SUBMIT_ORDER_CLICKED", value: status })
};

export const fNameErr = (status, dispatch) => {
    dispatch({ type: Deposit.fNameErr, value: status })
};

export const lNameErr = (status, dispatch) => {
    dispatch({ type: Deposit.lNameErr, value: status })
};

export const cTypeErr = (status, dispatch) => {
    dispatch({ type: Deposit.cTypeErr, value: status })
};

export const cNumErr = (status, dispatch) => {
    dispatch({ type: Deposit.cNumErr, value: status })
};

export const cVVErr = (status, dispatch) => {
    dispatch({ type: Deposit.cVVErr, value: status })
};

export const expMonthErr = (status, dispatch) => {
    dispatch({ type: Deposit.expMonthErr, value: status })
};

export const expYearErr = (status, dispatch) => {
    dispatch({ type: Deposit.expYearErr, value: status })
};
